export default "__VITE_ASSET__wgZa$ws4__"